class AppData {
    constructor() {
        if (!AppData.instance) {
            this.data = null
            AppData.instance = this
        }
        return AppData.instance;
    }
    init(app) {
        if (this.data == null) {
            this.data = app
            Object.freeze(AppData.instance);
        }
    }
    createTableSession(pin) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "/table/" + this.data.state.table.id + "/join_table",
                type: "post",
                data: {
                    pin: pin
                },
                success: (response) => {
                    console.log('success')
                    console.log(response)
                    let message = lang.your_pin
                    // let result = message.replace("*PIN*", pin)
                    // alert(result)
                    table_session_id = response['id']
                    $('#table-pin-modal').modal('hide')
                    this.data.newSession()
                    resolve()
                },
                fail: (e) => {
                    console.log('fail')
                    console.error(e)
                    alert(e)
                    reject(e)
                },
                error: (e) => {
                    if(e.responseJSON != null){
                        reject(e.responseJSON.message)
                    }
                    reject(e.responseText)
                }
            })
        })
    }

    getPeakHours = (appSettings) => {
        // App default setting
        let peakHourSetting = (appSettings || []).find(appSetting => appSetting.setting == 'peak_hours')

        // Override with merchant specific setting if exists
        const merchantPeakHour = this.data.getMerchantSettingValue('peak_hours')
        if (merchantPeakHour) {
            peakHourSetting = {value: merchantPeakHour}
        }
        
        let peakHourStr = peakHourSetting && peakHourSetting.value
        if (peakHourStr) {
            let peakHourStrs = peakHourStr.split(",")
            let peakHours = peakHourStrs.map(str => {
                let times = str.split("-")
                let start = moment(times[0], "HH:mm")
                let end = moment(times[1], "HH:mm")
                return {start, end}
            })
            return peakHours
        }
        return []
    }
    getPeakHoursAsString = (appSettings) => {
        const peakHours = this.getPeakHours(appSettings)
        let peakHourStrs = []
        for (let i = 0; i < peakHours.length; i++) {
            let peakHour = peakHours[i]
            peakHourStrs.push(peakHour.start.format('hh:mm a') + " - " + peakHour.end.format('hh:mm a'))
        }
        return peakHourStrs
    }
    isPeakHour = (appSettings, time) => {
        let peakHours = this.getPeakHours(appSettings)
        const timeToCompare = moment()

        // Set time to today for comparison
        timeToCompare.set({
            hour: time.hour(),
            minute: time.minute(),
            second: 0,
            millisecond: 0,
        })

        for (let i = 0; i < peakHours.length; i++) {
            let peakHour = peakHours[i]

            // [] mean inclusive comparison
            if (timeToCompare.isBetween(peakHour.start, peakHour.end, undefined, '[]')) {
                return true
            }
        }
        return false
    }
}

const instance = new AppData();
window.AppData = instance;
export default instance;